/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames'
// @ts-ignore
import s from './AdminReport.css';
import BrandComplete from '../../components/BrandComplete'
import SeleTime from '../../components/SeleTime'
import moment from 'moment'

import ReportHistory from '../../components/ReportHistory'
import ReportDimension from '../../components/ReportDimension'
import ReportBattleDB from '../../components/ReportBattleDB'
import ReportBattleDimensions from '../../components/ReportBattleDimensions'

import BrandVInfo from './BrandVInfo'
import AdminBackNav from '../adminBackNav/adminBackNav';

const emotionList=[
  {
    type:'emotion',
    txt:'好感度'
  },{
    type:'participate',
    txt:'参与度'
  },{
    type:'spread',
    txt:'传播度'
  }
]

const platform=[
  {
    txt:'微信',
    field:'wx',
    attr:'wechat',
    color:'#c2e1c5'
  },{
    txt:'微博',
    field:'wb',
    attr:'weibo',
    color:'#fac8a7'
    
  },{
    txt:'知乎',
    field:'zh',
    attr:'zhihu',
    color:'#abd9f2'
    
  },{
    txt:'今日头条',
    field:'tt',
    attr:'toutiao',
    color:'#f1b1ad'
  },{
    txt:'悟空问答',
    field:'wk',
    attr:'wukong',
    color:'#f1b1ad'
  }
]

const pdfBtn=[
  {
    txt:'一周数字品牌价值走势',
    fn:'getReportDB'
  },{
    txt:'数字品牌价值及三维度',
    fn:'getReportOneDayDB'
  },{
    txt:'数字品牌价值 – 重点竞品对⽐',
    fn:'getReportBattleDB'
  },{
    txt:'⽤户参与及好感 – 重点竞品对⽐',
    fn:'getReportBattleDimensions'
  },{
    txt:'竞品数字品牌价值及舆情监测',
    fn:'getReportOneDayDBCount'
  }
]

const countHead=[
  'id',
  '官网名称',
  'key',
  '平台',
  '操作'
]

const tableTit=[
  '',
  '平台',
  '文章url',
  '文章标题',
  '阅读数',
  '转发数',
  '评论数',
  '点赞数',
  '发布日期',
  '关联品牌&感情倾向'
]

class AdminReport extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      brandName: '',
      seaValue: '',
      timeStart: '',
      timeEnd: '',
      timeStartShow: false,
      timeEndShow: false,
      charts: [],
      charts2:[],
      summary: {},
      battleBrand:'',
      battleList:[],
      emotion:0,
      battleColor:'#c2e1c5',
      doFn:'getReportDB',
      platformAc:0,
      vValue:'',
      countData:[],
      showBrandVInfo:false,
      showBrandVData:{},
      tableData:[],
      keyWorld:'',
      battleNow:0,
      isShowLabel:true,
    }

    this.seaComplete = this
      .seaComplete
      .bind(this)
    this.handleSubmit = this
      .handleSubmit
      .bind(this)
    this.getReportBattleDimensions=this.getReportBattleDimensions.bind(this)

    this.exportList = this.exportList.bind(this);
  }



  seaComplete = (e) => {
    const {value} = e.target
    this.setState({seaValue: value})

  }

  componentDidMount() {
    // this.getBrandInfo()
    this.getReportDB({})
  }

  getBrandInfo = (brand) => {

    const url = `/dbrankCMS/getBrandInfo?brandName=${brand || ''}`

    // this.setState({brandName:brand})
    const myInit = {
      method: 'GET',
      credentials: 'include',
      mode: 'cors',
      cache: 'no-cache'
    };
    fetch(url, myInit)
      .then(response => response.json())
      .then(data => {
        console.log(data, 'data')

        this.setState({brandName: data.brandName})
        if (data.errorCode == 404) {
          this.setState({data: [], newData: []})
          alert('请输入正确品牌')

        }

        if (data.errorCode == 2) {
          alert('请重新登录！')
        }
      })
      .catch(e => {
        console.log('err', e)
        this.setState({data: [], newData: []})
        alert('请输出正确品牌')
      })

  }
  handleSubmit = (brand) => {
    // e.preventDefault() this.getBrandInfo(this.state.seaValue) this.setState({})
    // console.log(typeof(brand), brand)
    if (typeof(brand) === 'object') {
      alert('请输入正确品牌')
    } else {
      // this.getBrandInfo(brand)
      this.setState({brandName:brand})

    }

  }

  getReportDB = ({brandName=this.state.brandName, timeStart=this.state.timeStart, timeEnd=this.state.timeEnd}) => {
    // const {brandName, timeStart, timeEnd} = this.state
    
    if(brandName&&timeStart&&timeEnd){

      const url = `/digitalAssets/report/getReportDB?brandName=${brandName}&startDate=${timeStart}&statisDate=${timeEnd}`
      const myInit = {
        method: 'GET',
        credentials: 'include',
        mode: 'cors',
        cache: 'no-cache'
      };
      fetch(url, myInit)
        .then(response => response.json())
        .then(data => {

      

          this.setState({charts: data.charts, summary: data.summary})
        })
        .catch(e => {
          console.log('err', e)
          const  data = {
            charts: [
              11,
              22,
              33,
              44,
              55,
              66,
              77
            ],
            summary: {
              maxDate: '2018-05-20',
              maxDB: '77',
              minDate: '2018-05-26',
              minDB: '11',
              sort: '微博平台>微信平台>今日头条平台>知乎平台>悟空平台'
            }
          }

          this.setState({charts: data.charts, summary: data.summary})
        })

    }
    
  }
  getReportOneDayDB = ({brandName=this.state.brandName,timeStart=this.state.timeStart, timeEnd=this.state.timeEnd,platformAc=this.state.platformAc}) => {
    // const {brandName, timeStart, timeEnd,platformAc} = this.state
    const platformUrl=platform[platformAc]['field']
    const url = `/digitalAssets/report/getReportOneDayDB?brandName=${brandName}&startDate=${timeStart}&statisDate=${timeEnd}&platform=${platformUrl}`
    const myInit = {
      method: 'GET',
      credentials: 'include',
      mode: 'cors',
      cache: 'no-cache'
    };
    fetch(url, myInit)
      .then(response => response.json())
      .then(data => {

      
        this.setState({charts: data.charts})
      })
      .catch(e => {
        console.log('err', e)
        
      })


    const url2 = `/digitalAssets/report/getReportOneDayDimensions?brandName=${brandName}&startDate=${timeStart}&statisDate=${timeEnd}&platform=${platformUrl}`
    fetch(url2, myInit)
    .then(response => response.json())
    .then(data => {

    
      this.setState({charts2: data})
    })
    .catch(e => {
      console.log('err', e)
      
    })

    
  }
  getReportBattleDB=({brandName=this.state.brandName, timeStart=this.state.timeStart, timeEnd=this.state.timeEnd,battleList=this.state.battleList},seaValue)=>{
    // const {brandName, timeStart, timeEnd,battleList} = this.state
    const url = ` /digitalAssets/report/getReportBattleDB?brandNames=${[brandName,...battleList,seaValue]}&startDate=${timeStart}&statisDate=${timeEnd}`
    // console.log(url)
    const myInit = {
      method: 'GET',
      credentials: 'include',
      mode: 'cors',
      cache: 'no-cache'
    };
    fetch(url, myInit)
      .then(response => response.json())
      .then(data => {

    

        this.setState({charts: data.charts})
      })
      .catch(e => {
        console.log('err', e)
        // const  data ={
        //   charts:[
        //     [11,22,33,44,55,66,77],
        //     [22,33,44,55,66,77,88],
        //     [33,44,55,66,77,88,99],
        //     [44,55,66,77,88,99,22],
        //   ]
        // }

        // this.setState({charts: data.charts})
      })
  }
  getReportBattleDimensions = ({emotion=this.state.emotion,seaValue=this.state.seaValue}) => {
    const {brandName, timeStart, timeEnd,battleList} = this.state
    const url = ` /digitalAssets/report/getReportBattleDimensions?brandNames=${[brandName,...battleList,seaValue]}&startDate=${timeStart}&statisDate=${timeEnd}&dimensions=${emotionList[emotion]['type']}`
    // console.log(url)
    const myInit = {
      method: 'GET',
      credentials: 'include',
      mode: 'cors',
      cache: 'no-cache'
    };
    fetch(url, myInit)
      .then(response => response.json())
      .then(data => {

        // data = {
        //   charts:[
        //     [11,22,33,44,55,66,77],
        //     [11,22,33,44,55,66,77],
        //     [11,22,33,44,55,66,77],
        //     [11,22,33,44,55,66,77],
        //   ]
        // }

        this.setState({charts: data.charts})
      })
      .catch(e => {
        console.log('err', e)
        // const  data ={
        //   charts:[
        //     [11,22,33,44,55,66,77],
        //     [22,33,44,55,66,77,88],
        //     [33,44,55,66,77,88,99],
        //     [44,55,66,77,88,99,22],
        //   ]
        // }

        // this.setState({charts: data.charts})
      })
  }
  getReportOneDayDBCount=({brandName=this.state,battleList=this.state.battleList,},battleNow=0)=>{
    const { timeStart, timeEnd,emotion} = this.state
    const url = ` /digitalAssets/report/getReportOneDayDBCount?brandName=${battleList[battleNow]}&startDate=${timeStart}&statisDate=${timeEnd}`
    const myInit = {
      method: 'GET',
      credentials: 'include',
      mode: 'cors',
      cache: 'no-cache'
    };
    fetch(url, myInit)
      .then(response => response.json())
      .then(data => {

        // data = {
        //   charts:[11,22,33,44,55,66,77],
            
          
        // }

        this.setState({charts: data.charts})
      })
      .catch(e => {
        console.log('err', e)
        const  data ={
          charts:[11,22,33,44,55,66,77],
           
        }

        this.setState({charts: data.charts})
      })
  }

  getReportBrandV=()=>{
    const {brandName, timeStart, timeEnd,emotion,platformAc} = this.state
    const url = ` /digitalAssets/report/getReportBrandV?brandName=${brandName}&platform=${platform[platformAc]['field']}`
    // console.log(url)
    const myInit = {
      method: 'GET',
      credentials: 'include',
      mode: 'cors',
      cache: 'no-cache'
    };
    fetch(url, myInit)
      .then(response => response.json())
      .then(data => {
          // data =[{"vName":"aaab","id":4,"key":"3.1415927","platform":"wk"}]
        
       

        this.setState({countData: data})
      })
      .catch(e => {
        console.log('err', e)
        const  data =[{"vName":"aaab","id":4,"key":"3.1415927","platform":"wk"}]

        this.setState({countData: data})
      })
      // const  data =[
      //   {"vName":"aaab","id":4,"key":"3.1415927","platform":"wk"},
      //   {"vName":"bbb","id":5,"key":"3.5","platform":"wk"},
      //   {"vName":"ccc","id":6,"key":"66","platform":"wk"},
      // ]
      
      //         this.setState({countData: data})
  }
  
  doDelReportBrandV=(id)=>{
    const {brandName, timeStart, timeEnd,battleList,emotion,platformAc} = this.state
    const url = ` /digitalAssets/report/doDelReportBrandV?id=${id}`
    console.log(url)
    const myInit = {
      method: 'GET',
      credentials: 'include',
      mode: 'cors',
      cache: 'no-cache'
    };
    fetch(url, myInit)
      .then(response => response.json())
      .then(data => {
        if(data.errCode==1){
          alert('操作失败！')
        }else{
          alert('操作成功！')
        }
        this.getReportBrandV()

      })
      .catch(e => {
        console.log('err', e)

      })
  }
  doChangeReportBrandV=(oldInfo,newInfo)=>{
    const {brandName, timeStart, timeEnd,battleList,emotion,platformAc} = this.state

    let url
    if( JSON.stringify(oldInfo)=='{}'){
      url = `/digitalAssets/report/doAddReportBrandV?brandName=${brandName}&platform=${newInfo['platform']}&vName=${newInfo.vName}&key=${newInfo.key}`
      
    }else{
      url = `/digitalAssets/report/doChangeReportBrandV?brandName=${brandName}&platform=${newInfo['platform']}&vName=${newInfo.vName}&id=${newInfo.id}&key=${newInfo.key}`
      
    }
    const myInit = {
      method: 'GET',
      credentials: 'include',
      mode: 'cors',
      cache: 'no-cache'
    };
    fetch(url, myInit)
      .then(response => response.json())
      .then(data => {
        if(data.errCode==1){
          alert('操作失败！')
        }else{
          alert('操作成功！')
        }
        this.setState({showBrandVInfo:false})
        this.getReportBrandV()
        
      })
      .catch(e => {
        console.log('err', e)

      })
  }
  doChangeEmotionReportBrandV=(key,platform)=>{
    const {brandName, timeStart, timeEnd,battleList,emotion,platformAc} = this.state
    const url = ` /digitalAssets/report/doChangeEmotionReportBrandV?brandName=${brandName}&key=${key}&platform=${platform}`
    console.log(url)
    const myInit = {
      method: 'GET',
      credentials: 'include',
      mode: 'cors',
      cache: 'no-cache'
    };
    fetch(url, myInit)
      .then(response => response.json())
      .then(data => {

        if(data.errCode==1){
          alert('操作失败！')
        }else{
          alert('操作成功！')
        }
        this.getReportBrandV()
      })
      .catch(e => {
        console.log('err', e)
      })
  }

  getReportKeyWorldArticle=()=>{
    const {brandName, timeStart, timeEnd,battleList,emotion,platformAc,keyWorld} = this.state
    const url = `/digitalAssets/report/getReportKeyWorldArticle?brandName=${brandName}&platform=${platform[platformAc]['attr']}&startTime=${timeStart}&statisTime=${timeEnd}&keyWorld=${keyWorld}`
    // const url = `/digitalAssets/mongotest?platform=weibo&statisDate=2018-05-27&startDate=2018-05-21&brandName=%E6%B5%B7%E5%B0%94&keywords=%E4%B8%96%E5%8D%AB,%E4%B8%96%E7%95%8C%E5%8D%AB%E7%94%9F%E7%BB%84%E7%BB%87`
    console.log(url)
    const myInit = {
      method: 'GET',
      credentials: 'include',
      mode: 'cors',
      cache: 'no-cache'
    };
    fetch(url, myInit)
      .then(response => response.json())
      .then(data => {
 
        this.setState({tableData:data})
        
      })
      .catch(e => {
        console.log('err', e)
 
      })
  }

  exportList () {
    const {brandName, timeStart, timeEnd,battleList,emotion,platformAc,keyWorld} = this.state
    const url = `/digitalAssets/report/getReportKeyWorldArticle?brandName=${brandName}&platform=${platform[platformAc]['attr']}&startTime=${timeStart}&statisTime=${timeEnd}&keyWorld=${keyWorld}&key=1`
    window.open(url, '_blank')
  }

  RenderCharts=({fn=this.state.doFn,timeStart=this.state.timeStart,timeEnd=this.state.timeEnd})=>{

    const {
      brandName,
      seaValue,
      timeStartShow,
      timeEndShow,
      charts,
      charts2,
      summary,
      battleBrand,
      battleList,
      emotion,
      battleColor,
      doFn,
      platformAc,
      battleNow,
      isShowLabel
    } = this.state

    

    switch (fn) {
      case 'getReportDB':
        return(
          <div>
            <ReportHistory
            tit={`${brandName}一周数字品牌价值`}
            startTime={timeStart}
            endTime={timeEnd}
            color='#ffd70d'
            showLabel={isShowLabel}
            json={charts}/>
            {JSON.stringify(summary)!=='{}'&&<div>
              <p>本周，{brandName}DB总值最⾼⽇为{moment(summary.maxDate).format('YYYY年MM月DD日')  ||''}，达到{parseFloat(summary.maxDB||'').toLocaleString()}；最低⽇为{moment(summary.minDate).format('YYYY年MM月DD日')}，为{parseFloat(summary.minDB).toLocaleString()}。</p>  
              <p>{brandName}在四⼤社交媒体平台上的数字价值和受关注程度依次为：{summary.sort}。</p>
            </div>}
          </div>
        )
        break;

      case 'getReportOneDayDB':
        return(
          <div>
            <select value={platformAc} onChange={(e)=>{
              this.setState({platformAc:e.target.value,battleColor:platform[e.target.value]['color']})
              this.getReportOneDayDB({platformAc:e.target.value})
              }}>
              {platform.map((i,index)=>
                <option key={index} value={index}    >{i.txt}</option>
              )}
            </select>
            <label>平台颜色 value:{battleColor}</label>
              <input style={{marginLeft:'20px'}} value={battleColor}  type='color' onChange={(e)=>this.setState({battleColor:e.target.value})} />
             <ReportHistory
                tit={`${brandName} ${platform[platformAc]['txt']}平台单日DB值`}
                startTime={timeStart}
                showLabel={isShowLabel}
                endTime={timeEnd}
                color={platform[platformAc]['color']}
                json={charts}/>
              <ReportDimension
                tit={`${brandName} ${platform[platformAc]['txt']}平台单日三维度曲线`}
                startTime={timeStart}
                showLabel={isShowLabel}
                endTime={timeEnd}
                color={platform[platformAc]['color']}
                json={charts2}/>
          </div>
        )
        break;
        
      case 'getReportBattleDB':     
        return(
          <div>
            <div>    
              <i>对比品牌：
                {battleList&&battleList.map((i,index)=>(
                  <span key={index} className={s.battleItem}>{i}
                    <em onClick={()=>{                         
                      battleList.splice(index,1)
                      this.setState({battleList})
                    }}>x</em>
                  </span>
                ))}
              </i>
            
              <BrandComplete 
                value={seaValue}
                isClearValue={true}
                getBrand={(seaValue)=>{
                  this.setState(prevState=>({
                    battleList:prevState.battleList.concat(seaValue),
                  }))
                  this.getReportBattleDB({},seaValue)
                }}
              />
              
              {/* <span className={s.readyBtn} onClick={this.getReportBattleDB}>刷新图表</span> */}
            </div>
            
            {battleList.length>0&&<ReportBattleDB
              tit={`${brandName}与主要竞品 数字品牌价值曲线`}
              startTime={timeStart}
            showLabel={isShowLabel}
              endTime={timeEnd}
              brands={[brandName,...battleList]}
              color={'#c2e1c5'}
              json={charts}
            />}

          </div>
        )
        break;
      
      case 'getReportBattleDimensions':
        return (
          <div>
            <div>
              <i>
                <select  value={emotion} 
                  onChange={(e)=>{
                    this.setState({emotion:e.target.value,})
                    this.getReportBattleDimensions({emotion:e.target.value,})
                    }}>
                  {emotionList.map((i,index)=>
                    <option value={index} key={index}>{i.txt}</option>
                  )}
                </select>
              </i>
              <i>对比品牌：
                {battleList&&battleList.map((i,index)=>(
                  <span key={index} className={s.battleItem}>{i}
                    <em onClick={()=>{                         
                      battleList.splice(index,1)
                      this.setState({battleList})
                    }}>x</em>
                  </span>
                ))}
              </i>
             
              <BrandComplete 
                value={seaValue} 
                isClearValue={true}
                getBrand={(seaValue)=>{
                  this.setState(prevState=>({
                    battleList:prevState.battleList.concat(seaValue),
                  }))
                  this.getReportBattleDimensions({seaValue})
                }}
              />
              {/* <span className={s.readyBtn} onClick={this.getReportBattleDimensions}>刷新图表</span> */}
            </div>
            <ReportBattleDimensions
                tit={`${brandName}与主要竞品 ${emotionList[emotion]['txt']}曲线对比`}
                startTime={timeStart}
            showLabel={isShowLabel}
                endTime={timeEnd}
                brands={[brandName,...battleList]}
                color={'#c2e1c5'}
                json={charts}
              />
          </div>
        )
        break;

      case 'getReportOneDayDBCount':
        return(
          <div>
            <div>
             
              <i>竞品品牌：
                {battleList&&battleList.map((i,index)=>(

                  
                  <span 
                    key={index} 
                    className={battleNow==index?cx(s.ac,s.battleItem):s.battleItem}
                    onClick={()=>{
                      this.setState({battleNow:index})
                      this.getReportOneDayDBCount({},index)
                    }}
                  >{i}
                    <em onClick={()=>{                         
                      battleList.splice(index,1)
                      this.setState({battleList})
                    }}>x</em>
                  </span>
                ))}
              </i>
            
              <BrandComplete 
                value={seaValue} 
                isClearValue={true}
                getBrand={(seaValue)=>{
                  this.setState(prevState=>({
                    battleList:prevState.battleList.concat(seaValue),
                    battleNow:prevState.battleList.length
                  }))
                  this.getReportOneDayDBCount({battleList:battleList.concat(seaValue)},battleList.length)
                }}
              />
              {/* <span className={s.readyBtn} onClick={this.getReportOneDayDBCount}>battleNow刷新图表</span> */}
              <label>竞品颜色 value:{battleColor}</label>
              <input style={{marginLeft:'20px'}} value={battleColor}  type='color' onChange={(e)=>this.setState({battleColor:e.target.value})} />
            </div>
            <ReportHistory
              tit={`${battleList[battleNow]} 四大社交媒体平台单日总DB值`}
              startTime={timeStart}
            showLabel={isShowLabel}
              endTime={timeEnd}
              color={battleColor}
              json={charts}/>
          </div>
        )
        break;


      default:
        break;
    }

  
  }



  render() {
    const {
      brandName,
      seaValue,
      timeStart,
      timeEnd,
      timeStartShow,
      timeEndShow,
      charts,
      summary,
      battleBrand,
      battleList,
      emotion,
      battleColor,
      doFn,
      platformAc,
      vValue,
      countData,
      showBrandVInfo,
      showBrandVData,
      tableData,
      keyWorld,
      isShowLabel
    } = this.state
    // console.log(data,data.length)
  
   
    

    

    return (
      <div className={s.root}>
        <AdminBackNav></AdminBackNav>

        <div className={s.container}>
          <h1>报告自动化</h1>
          <div className={s.seaItem}></div>
          <div style={{
            height: '70px',
            display:'inLine-flex'
          }}>
            <BrandComplete value={seaValue} getBrand={this.handleSubmit}/> {/* <span onClick={this.handleSubmit} style={{lineHeight:'30px',}}>搜索</span> */}
          <div className={s.anySeletTime}>
            <div className={s.anyTimeBox}>
              开始时间：
              <SeleTime canOnchangeDate={true} topTime={(time)=>{
                this.setState({timeStart:time})
                this[this.state.doFn]({timeStart:time})
                
                }} />   
            </div>
            <div className={s.anyTimeBox}>
              结束时间：
              <SeleTime canOnchangeDate={true} topTime={(time)=>{
                this.setState({timeEnd:time})
                this[this.state.doFn]({timeEnd:time})
                
                }} />
            </div>
            {/* <span className={s.readyBtn} onClick={this.getAnyTimeChartsJson}>选好时间了！</span> */}
          </div>
          <span className={s.spanLabel}>是否显示label</span>
          
          <div className={s.switchBox}>
            <label className={s.switch}>
              <input type="checkbox"
                onChange={()=>this.setState({isShowLabel:!isShowLabel})}
              checked={isShowLabel?'checked':null}/>
              <span 
                className={cx(s.slider,s.round)}
              ></span>
            </label>
          </div>
          </div>
          <div className={s.listBox}>
            <ul className={s.flexUl}>
              {pdfBtn.map(i=>
                <li 
                  className={doFn==i.fn?cx(s.chartsBtn,s.ac):s.chartsBtn}
                  key={i.fn} 
                  onClick={()=>{
                    this.setState({charts:[],doFn:i.fn})
                    this[i.fn]({})
                  }}>{i.txt}</li>
              )}
            </ul>
            {this.RenderCharts({fn:doFn})}
            
          </div>
        </div>
        <div className={s.container}>
          <h2>官方账号</h2>
          <span className={s.countBrand}>查询品牌：{brandName}</span>
          {/* <input value={vValue}
            defaultValue={brandName}
            onChange={(e)=>this.setState({vValue:e.target.value})}
            onKeyDown={(e)=>{
              if(e.keyCode=='13'){
                this.getReportBrandV()
              }
            }}
          /> */}
          <span className={s.brandVadd} onClick={()=>this.setState({showBrandVInfo:true,showBrandVData:{}})}>创建</span>
          <select value={platformAc} onChange={(e)=>this.setState({platformAc:e.target.value})}>
            {platform.map((i,index)=>
              <option  key={index} value={index} >{i.txt}</option>
            )}
          </select>
          <span className={s.searchCountBtn} onClick={this.getReportBrandV}>查询</span>
          <div className={s.posi}>

          <table  cellSpacing="0" cellPadding="2" className={s.countTableCls}>
            <thead>
              <tr>
                {countHead.map(i=><th key={i}>{i}</th>)}
              </tr>
            </thead>
            <tbody>
              {countData.map((i,index)=>
                <tr key={index}>
                  <td>{i.id}</td>
                  <td>{i.vName}</td>
                  <td>{i.key}</td>
                  <td>
                    {i.platform}
                  </td>
                  <td>
                    <span style={{cursor:'pointer'}}
                    onClick={()=>{
                      if(confirm(`确定批量修改 官方名称为 ${i.vName} 的账号 情感倾向？`)){
                        this.doChangeEmotionReportBrandV(i.key,i.platform)
                      }}} 
                     >批量中立</span>
                    /
                    <span style={{cursor:'pointer'}} onClick={()=>this.setState({showBrandVInfo:true,showBrandVData:countData[index]})} >修改</span>
                    /
                    <span onClick={()=>{
                      if(confirm(`确定删除 官方名称为 ${i.vName} 的账号？`)){
                        this.doDelReportBrandV(i.id)
                      }}} 
                      style={{cursor:'pointer',color:'red'}}>删除</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          {showBrandVInfo&&<BrandVInfo doChange={this.doChangeReportBrandV} close={()=>this.setState({showBrandVInfo:false})} data={showBrandVData}    />}
          </div>
          
        </div>
        <div className={s.container}>
          <h2>文章查询</h2>
          <span className={s.countBrand}>查询品牌：{brandName}</span>
          <label>关键词</label>
          <input value={keyWorld}
             onChange={(e)=>this.setState({keyWorld:e.target.value})}
          />
          
          <select value={platformAc} onChange={(e)=>this.setState({platformAc:e.target.value})}>
            {platform.map((i,index)=>
              <option  key={index} value={index} >{i.txt}</option>
            )}
          </select>
          <span className={s.searchCountBtn} onClick={this.getReportKeyWorldArticle}>查询</span>
          <span className={s.searchCountBtn} onClick={this.exportList}>导出</span>
          <div className={s.tableBox}>

          {tableData.length>0?
            <table cellSpacing="0" cellPadding="0">
            <thead>
              <tr>
                {tableTit.map((i,index)=>
                  <th key={index}>{i}</th>
                )}
              </tr>
            </thead>
              <tbody>
                {tableData.map((i,index)=>
                  <tr key={index}>
                    <th>{index+1}</th>
                    <td>{i.pltform}</td>
                    <td>
                      <a href={i.url} target='_blank'>
                        {i.url}
                      </a>
                    </td>
                    <td>{i.tit}</td>
                    <td>{i.readCount}</td>
                    <td>{i.repostsCount}</td>
                    <td>{i.commentsCount}</td>
                    <td>{i.attitudesCount}</td>
                    <td>{i.date}</td>
                    <td>
                      {i.brandList.map(j=><span key={j.name}>{j.name}:{j.emotion}   </span>)}
                    </td>
                  </tr>
                )}
              </tbody>
          </table>
              
            :null}
          </div>
            
        </div>
      </div>
    );
  }
}

export default withStyles(s)(AdminReport);



// WEBPACK FOOTER //
// src/routes/adminReport/AdminReport.js